import { IReduxActionMessage } from '../types';
import { EAddFavoritesActionTypes, EDeleteFavoritesActionTypes } from '../actions/favorites';
import { TThunkDispatch } from '../../../../shared/types/redux';
import { addFavorite, deleteFavorite } from '../../../../shared/actions/favorites';

export function reduxActionMessageHandler(message: IReduxActionMessage, dispatch: TThunkDispatch) {
  switch (message.value.type) {
    case EDeleteFavoritesActionTypes.Failure:
    case EAddFavoritesActionTypes.Request:
      dispatch(addFavorite(message.value.payload.offerId));
      break;
    case EDeleteFavoritesActionTypes.Request:
    case EAddFavoritesActionTypes.Failure:
      dispatch(deleteFavorite(message.value.payload.offerId));
      break;
  }
}
